/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../../_chunks/dep-e43cf21c.js';
import { useState, useEffect } from 'react';
import useControlled from '../../hooks/useControlled.js';
import { getDefaultFormat, isValidDate, initYearMonthTime, formatDate, formatTime } from '../../_common/js/date-picker/format.js';
import { extractTimeFormat } from '../../_common/js/date-picker/utils.js';
import '../../_common/js/log/index.js';
import log from '../../_common/js/log/log.js';
import '../../_chunks/dep-2acfafca.js';
import '../../_chunks/dep-f721d103.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-4559db64.js';
import '../../_chunks/dep-c00532d4.js';
import '../../_chunks/dep-33ffecad.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_util/noop.js';
import '../../_chunks/dep-6c5254c6.js';
import 'dayjs';
import '../../_chunks/dep-46de7b2e.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-fdce1f4f.js';
import '../../_chunks/dep-77a54538.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-6506fbc2.js';

var PARTIAL_MAP = {
  first: "start",
  second: "end"
};
function useRange(props) {
  var _useControlled = useControlled(props, "value", props.onChange),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    value = _useControlled2[0],
    onChange = _useControlled2[1];
  var _getDefaultFormat = getDefaultFormat({
      mode: props.mode,
      format: props.format,
      enableTimePicker: props.enableTimePicker
    }),
    format = _getDefaultFormat.format,
    timeFormat = _getDefaultFormat.timeFormat;
  if (props.enableTimePicker) {
    if (!extractTimeFormat(format)) log.error("DatePicker", "format: ".concat(format, " \u4E0D\u89C4\u8303\uFF0C\u5305\u542B\u65F6\u95F4\u9009\u62E9\u5FC5\u987B\u8981\u6709\u65F6\u95F4\u683C\u5F0F\u5316 HH:mm:ss"));
  }
  if (!Array.isArray(value)) {
    log.error("DatePicker", "typeof value: ".concat(value, " must be Array!"));
  } else if (!isValidDate(value, format)) {
    log.error("DatePicker", "value: ".concat(value, " is invalid dateTime! Check whether the value is consistent with format: ").concat(format));
  }
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFirstValueSelected = _useState2[0],
    setIsFirstValueSelected = _useState2[1];
  var _useState3 = useState(initYearMonthTime({
      value: value,
      mode: props.mode,
      format: format,
      enableTimePicker: props.enableTimePicker
    }).time),
    _useState4 = _slicedToArray(_useState3, 2),
    time = _useState4[0],
    setTime = _useState4[1];
  var _useState5 = useState(initYearMonthTime({
      value: value,
      mode: props.mode,
      format: format,
      enableTimePicker: props.enableTimePicker
    }).month),
    _useState6 = _slicedToArray(_useState5, 2),
    month = _useState6[0],
    setMonth = _useState6[1];
  var _useState7 = useState(initYearMonthTime({
      value: value,
      mode: props.mode,
      format: format
    }).year),
    _useState8 = _slicedToArray(_useState7, 2),
    year = _useState8[0],
    setYear = _useState8[1];
  var _useState9 = useState(formatDate(value, {
      format: format
    })),
    _useState10 = _slicedToArray(_useState9, 2),
    cacheValue = _useState10[0],
    setCacheValue = _useState10[1];
  useEffect(function () {
    if (!value) {
      setCacheValue([]);
      return;
    }
    if (!isValidDate(value, format)) return;
    setCacheValue(formatDate(value, {
      format: format
    }));
    setTime(formatTime(value, timeFormat, props.defaultTime));
  }, [value]);
  return {
    value: value,
    onChange: onChange,
    year: year,
    setYear: setYear,
    month: month,
    setMonth: setMonth,
    time: time,
    setTime: setTime,
    isFirstValueSelected: isFirstValueSelected,
    setIsFirstValueSelected: setIsFirstValueSelected,
    cacheValue: cacheValue,
    setCacheValue: setCacheValue
  };
}

export { PARTIAL_MAP, useRange as default };
//# sourceMappingURL=useRangeValue.js.map
